module.exports = __webpack_public_path__ + "img/australia-eye-and-ear-diseases-female.b68bf534.png";